import { isDesktopShellEnvironment } from "./desktopShell";

let desktopBackendOrigin: string | null = null;

const isAbsoluteUrl = (value: string) => /^[a-zA-Z][a-zA-Z\d+.-]*:/.test(value);

const getRuntimeBrowserOpenUrl = () =>
  (window as { runtime?: { BrowserOpenURL?: (url: string) => void } }).runtime?.BrowserOpenURL;

export const buildExternalUrl = async (path: string): Promise<string> => {
  if (typeof window === "undefined" || isAbsoluteUrl(path)) {
    return path;
  }

  let baseOrigin = window.location.origin;

  if (isDesktopShellEnvironment()) {
    if (!desktopBackendOrigin) {
      try {
        const response = await fetch("/__desktop_meta", { cache: "no-store" });
        if (response.ok) {
          const payload = (await response.json().catch(() => null)) as { backendAddr?: unknown } | null;
          const backendAddr = typeof payload?.backendAddr === "string" ? payload.backendAddr.trim() : "";
          if (backendAddr) {
            desktopBackendOrigin = `http://${backendAddr}`;
          }
        }
      } catch {
        // Fall back to the current origin when desktop metadata is unavailable.
      }
    }

    if (desktopBackendOrigin) {
      baseOrigin = desktopBackendOrigin;
    }
  }

  return new URL(path, `${baseOrigin}/`).toString();
};

export const openExternalPath = async (path: string): Promise<void> => {
  if (typeof window === "undefined") {
    return;
  }

  const targetUrl = await buildExternalUrl(path);
  const browserOpenUrl = getRuntimeBrowserOpenUrl();

  if (isDesktopShellEnvironment() && typeof browserOpenUrl === "function") {
    browserOpenUrl(targetUrl);
    return;
  }

  window.open(targetUrl, "_blank", "noopener,noreferrer");
};
